<template>
	<div class="survey survey-thanks">
		<div class="survey-container">
			<template v-if=" ! clientRegister">
				Tack för ditt svar!
			</template>

			<template v-if="clientRegister">
				<h2>{{ clientRegister.thanks_title }}</h2>

				<div class="mt-5" v-html="clientRegister.thanks_text_below_title"></div>
			</template>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'Vue',

	data() {
		return {
			clientRegister: null
		}
	},

	created() {
		this.$store.state.loading = true

		let slug = this.$route.params.slug || this.$store.state.endUser?.slug

		axios.get(this.$apiUrl + '/api/client-register', {params: {slug}}).then(res => {
			this.clientRegister = res.data.clientRegister
			this.$store.state.loading = false
		}).catch(e => {
			this.$store.state.loading = false
		})

		setTimeout(() => {
			if ( ! this.clientRegister) {
				if (this.$route.params.slug) {
					this.$router.push({name: 'EndUser', params: {slug: this.$route.params.slug}})
				} else {
					window.location.replace('https://nudgd.se')
				}
			}
		}, 3000)	
	}
}
</script>